import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';

export interface LoadingSectionProps {
  outerClassName?: string;
  innerClassName?: string;
}

export const LoadingSection = ({
  outerClassName,
  innerClassName,
}: LoadingSectionProps) => {
  return (
    <div
      className={cn(
        'grid size-14 animate-spin grid-cols-2 items-center justify-items-center rounded-full bg-gray-50 p-1',
        outerClassName
      )}
      {...createDataAttributes({
        test: 'loading',
      })}
    >
      {Array.from({ length: 4 }).map((o, i) => (
        <span
          key={i}
          className={cn('block size-2 rounded-full bg-red-500', innerClassName)}
        />
      ))}
    </div>
  );
};
